module.exports = __webpack_public_path__ + "img/rightArrow.2bc25b29.svg";